import React from 'react';
import type { ServiceMutationType } from 'Utils/graphql-query-helper/booking/proposal/proposalQuery';
import 'Utils/graphql-query-helper/booking/proposal/proposalQuery';
type ActivitiesContextType = {
  attendeesList: ReadonlyArray<{
    readonly birthdate: string;
    readonly firstName?: string;
    readonly id: string;
    readonly isChild: boolean;
    readonly lastName?: string;
    readonly unicodeFirstName?: string;
    readonly unicodeLastName?: string;
  }>;
  availableActivities: ReadonlyArray<AdditionalServiceWithScheduleType>;
  currency: string;
  deleteService: (
    services: ReadonlyArray<AdditionalServiceWithScheduleType>,
    attendeeIds: ReadonlyArray<string> | string,
  ) => Promise<any>;
  onlyBookableServices?: boolean;
  trackingData: Readonly<{
    actionGA: string;
    categoryGA: string;
  }>;
  updateService: (
    attendees: ServiceMutationType,
    pricingInfo: PricingInfoWithScheduleType,
    serviceIds: ReadonlyArray<string>,
    attendeeIds: ReadonlyArray<string>,
  ) => Promise<any>;
};
export const ActivitiesContext = React.createContext<ActivitiesContextType>(
  {} as ActivitiesContextType,
);
